<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 入账编號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
					<!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">入账</el-button> -->
					<el-tag class="ml-3" type="warning">總金額：{{total_list.money}}</el-tag>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="入账编號" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索入账编號"></el-input>
						</el-form-item>
						
						<el-form-item label="明细" class="mb-0">
							<el-input size="small" v-model="from.info" placeholder="搜索明细"></el-input>
						</el-form-item>
						
						<el-form-item label="店铺" class="mb-0">
							<el-select  v-model="from.shop_id" size="small" filterable placeholder="請選擇" >
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="店長" class="mb-0">
							<el-select  v-model="from.sid" size="small" filterable placeholder="請選擇" >
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in sad_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="项目" class="mb-0">
							<el-select v-model="from.parent_type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="销售成本" :value="1"></el-option>
								<el-option label="管理成本" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="分類" class="mb-0">
							<el-select  v-model="from.class_id" size="small" filterable placeholder="請選擇" >
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in all_clist" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="产品" class="mb-0">
							<el-select  v-model="from.pid" size="small" filterable placeholder="請選擇" >
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in product" :key="item.id" :label="item.name+'( '+item.number+' )'" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
					
						
						
					
						
					
				
						
				

					
						
					


						<el-form-item label="入账時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<!-- <el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column> -->
				
				
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
			
				
				
		
				
				<el-table-column width="210" align="center" prop="order_no" label="入账编號"></el-table-column>
				<el-table-column align="center" width="120" prop="shop_name" label="所属店铺"></el-table-column>
				<el-table-column align="center" width="120" prop="sad_name" label="入账店長"></el-table-column>
				
				
				<el-table-column align="center" width="100"  prop="status"  label="项目">
					<template slot-scope="v">
						<span style="color: teal;" v-if="v.row.parent_type==1">销售成本</span>
						<span style="color: #67C23A;" v-if="v.row.parent_type==2" type="success">管理成本</span>
					</template>
				</el-table-column>
				
			
				
				
				<el-table-column align="center" prop="class_name" width="100"  label="分類"></el-table-column>
				<el-table-column align="center" prop="info" width="120"  label="明细"></el-table-column>
				
				<el-table-column align="center" prop="num"  label="數量"></el-table-column>
				<el-table-column align="center" prop="price" width="100"  label="單价"></el-table-column>
				<el-table-column align="center" prop="total" width="100"  label="金額"></el-table-column>
				<el-table-column align="center" prop="pro_name" width="150"  label="产品"></el-table-column>
	
			
		
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 -->
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="入账時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="80" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">编辑</el-button>
							
						<!-- 	<el-button @click="deleteItem(scope.row)"  v-auth="'delRule'" size="mini" plain type="danger">删除</el-button> -->

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog  :close-on-click-modal="false" :title="editIndex==-1?'成本入账':'修改入账'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				<el-form-item label="项目"   prop="parent_type">
					<el-radio-group @change="selPt" :disabled="editIndex>0?true:false" v-model="form.parent_type">
					    <el-radio :label="1" border>销售成本</el-radio>
					    <el-radio :label="2" border>管理成本</el-radio>
					  </el-radio-group>
				</el-form-item>
				
				
				<el-form-item label="分類" prop="class_id">
					<el-select @change="selClassify" v-model="form.class_id" size="small" filterable placeholder="請選擇" style="width: 85%;" >
						<el-option v-for="item in c_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item v-show="form.is_product==1" label="对应产品" prop="pid">
					<el-select  v-model="form.pid" size="small" filterable placeholder="請選擇" style="width: 85%;" >
						<el-option v-for="item in product" :key="item.id" :label="item.name+'( '+item.number+' )'" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="明细" prop="info">
					<el-input type="text" v-model="form.info" 
					placeholder="明细(備註)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item label="數量" prop="num">
					<el-input type="number" v-model="form.num"  @input="jisTotal"
					placeholder="數量" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="單价" prop="price">
					<el-input type="number" v-model="form.price"  @input="jisTotal"
					placeholder="單价" 
					clearable size="small" style="width: 85%;">
					<template slot="prepend">HK$</template>
					</el-input>
				</el-form-item>
				
				
				<el-form-item label="金額" prop="total">
					<span>HK$ {{form.total}}</span>
				</el-form-item>
			
				
				
				
	
				
			
				
			
			
				
		
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					class_id: [{
							required: true,
							message: "請選擇分類",
							trigger: 'blur',
						},
					],
					info: [{
							required: true,
							message: "明细不能为空",
							trigger: 'blur',
						},
					],
					num: [{
							required: true,
							message: "請輸入數量",
							trigger: 'blur',
						},
					],
					price: [{
							required: true,
							message: "請輸入單价",
							trigger: 'blur',
						},
					],
					
					
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					shop_id:-1,
					sid:-1,
					parent_type:-1,
					class_id:-1,
					pid:-1,
					info:'',
					time: [],
				},
				model_title: 'Cost',
				auth_val: 'Cost',
				preUrl: "user/costList", //列表地址
				addUrl: "user/addCost", //添加/修改地址
				editStatusUrl: "user/editStatusCost", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					parent_type:1,
					is_product:0,
					class_id:'',
					pid:"",
					num:'',
					price:'',
					info:'',
					total:0
					
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				paylist:[],
				guanlist:[],
				c_list:[],
				product:[],
				all_clist:[],
				shop_list:[],
				sad_list:[]
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('costClass');
		},
		methods: {
			jisTotal(){
				if(this.form.num && this.form.price){
					this.form.total = this.form.num * this.form.price
				}
			},
			selClassify(e){
				let item = this.c_list.find(v=>v.id==e)
				this.form.is_product = item.is_product
			},
			selPt(e){
				if(e==1){
					this.c_list = this.paylist
				}else{
					this.c_list = this.guanlist
				}
				this.form.class_id = ''
				this.form.is_product = 0
			},
			commonList(type){
					this.axios.post('/admin/user/commonList',
						{type:type}
					, {
						token: true,
					}).then(res => {
						let all = res.data
						
						let list = all.data.list
						this.all_clist = list.all
						this.shop_list = list.shop
						this.sad_list = list.sad
						this.paylist = list.pay
						this.guanlist = list.guan
						this.product = list.pro
				
						
					}).catch(err => {
						// 失敗
						
					})
				
			},
			
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
						
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						parent_type:e.parent_type,
						class_id: e.class_id,
						is_product: e.is_product,
						pid: e.pid,
						num:e.num,
						price:e.price,
						info:e.info,
						total:e.total
					}
					this.editIndex = e.id
					
					if(e.parent_type==1){
						this.c_list = this.paylist
					}else{
						this.c_list = this.guanlist
					}
				}else{
					this.form = {
						id: 0,
						parent_type:1,
						is_product:0,
						class_id:'',
						pid:"",
						num:'',
						price:'',
						info:'',
						total:0
					}
					this.editIndex = -1
					this.c_list = this.paylist
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					shop_id:-1,
					sid:-1,
					parent_type:-1,
					class_id:-1,
					pid:-1,
					info:'',
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
